const body = document.querySelector('body');

// // bodyにloadedクラスを追加
// document.addEventListener('DOMContentLoaded', function () {
//   // const body = document.querySelector('body');
//   body.classList.add('loaded');
// });

// // 前のスクロール位置を保持する変数
// let lastScrollTop = 0;

// window.addEventListener(
//   'scroll',
//   () => {
//     const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

//     // スクロール位置が0より大きいかどうかをチェックして、`scrolled`クラスを付与または削除
//     if (currentScrollTop > 0) {
//       document.body.classList.add('scrolled');
//     } else {
//       document.body.classList.remove('scrolled');
//     }

//     // スクロール方向に基づいて`scroll-up`または`scroll-down`クラスを切り替え
//     if (currentScrollTop > lastScrollTop) {
//       // 下にスクロールした場合
//       document.body.classList.remove('scroll-up');
//       document.body.classList.add('scroll-down');
//     } else if (currentScrollTop < lastScrollTop) {
//       // 上にスクロールした場合
//       document.body.classList.remove('scroll-down');
//       document.body.classList.add('scroll-up');
//     }

//     // 現在のスクロール位置を更新
//     lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // ネガティブな値を避ける
//   },
//   false,
// );

// メニューバーを追加する
document.addEventListener('DOMContentLoaded', function () {
  // 親要素を取得
  var $nav = document.querySelector('nav.global-nav');

  // 新しいdiv要素を作成
  var $menuBtn = document.createElement('div');
  $menuBtn.className = 'menu-btn nav-btn';
  $menuBtn.id = 'menu-btn';
  // div内にバーを追加
  for (var i = 0; i < 3; i++) {
    var bar = document.createElement('div');
    bar.className = 'menu-btn-bar';
    $menuBtn.appendChild(bar);
  }

  // nav要素の後ろに新しいdivを挿入
  $nav.appendChild($menuBtn);

  // メニュー開いたらクラス名をつける
  if ($menuBtn) {
    $menuBtn.addEventListener('click', () => $nav.classList.toggle('menu-open'));
  }
});
